import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AristoDashboardComponent } from './aristo-dashboard/aristo-dashboard.component';
import { DashboardComponent } from './dashboard/dashboard.component';


const routes: Routes = [
  {path : '', component : AristoDashboardComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DashboardRoutingModule { }
